// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Le Plan IGN v2 est un fond coloré : on le désature pour retrouver le rendu
 * « niveaux de gris » sur lequel comptent les couches thématiques posées
 * au-dessus (aléas, immobilier, isochrones…), qui portent toute la couleur.
 * Leaflet pose \`className\` sur le conteneur de la couche : le filtre s'applique
 * donc à l'ensemble de ses tuiles.
 */
.gray-scale-tiles {
    filter: grayscale(1) brightness(1.05);
}
`, "",{"version":3,"sources":["webpack://./src/main/js/utils/map/basemaps.css"],"names":[],"mappings":"AAAA;;;;;;EAME;AACF;IACI,qCAAqC;AACzC","sourcesContent":["/*\n * Le Plan IGN v2 est un fond coloré : on le désature pour retrouver le rendu\n * « niveaux de gris » sur lequel comptent les couches thématiques posées\n * au-dessus (aléas, immobilier, isochrones…), qui portent toute la couleur.\n * Leaflet pose `className` sur le conteneur de la couche : le filtre s'applique\n * donc à l'ensemble de ses tuiles.\n */\n.gray-scale-tiles {\n    filter: grayscale(1) brightness(1.05);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
